import styled from 'styled-components'
import { InputUnstyled } from './unstyled'

export const InputV2 = styled(InputUnstyled)`
  position: relative;

  input {
    position: relative;
    width: 100%;
    border-radius: 4px;
    height: 52px;
    background: #f8f8f8;
    border: none;
    padding: ${props => (props.icon ? '0 20px 0 54px' : '0 20px')};
    color: ${props => props.theme.colors.secondary};
    font-size: ${props => props.theme.fontSizes.form.input};
    outline: none;

    ::placeholder {
      font-size: ${props => props.theme.fontSizes.form.placeholder};
      color: ${props => props.theme.colors.placeholder};
      letter-spacing: 0.6px;
    }
  }
  input[disabled] {
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')}!important;
  }

  .labelContainer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .errorStyles {
    border: 1px solid red;
  }

  .icon {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 23px;
    right: auto;
    margin: auto;
  }

  .label {
    display: block;
    padding: 0;
    text-align: left;
    font-size: ${props => props.theme.fontSizes.form.label};
    color: ${props => props.theme.colors.secondary};
    font-family: ${props => props.theme.fonts.robotoRegular};
    line-height: 24px;
    margin: 0 0 10px 0;
  }

  .hint {
    position: absolute;
    background: ${props => props.theme.colors.primary};
    color: white;
    z-index: 10;
    margin-left: 30px;
    border-radius: 6px;
    width: 500px;
    padding: 10px;
  }
  .labelBox {
    display: flex;
    flex-direction: row;
  }
  .infoIcon {
    margin-left: 10px;
  }
`
